/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateOutputHtmlProxyAutoTestDataParser = 
/* #__PURE__ */ parsers.object([
    ['allowRemoteResources', codecBoolean, 'allow_remote_resources'],
    ['allowRemoteScripts', codecBoolean, 'allow_remote_scripts'],
]);
export class CreateOutputHtmlProxyAutoTestData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateOutputHtmlProxyAutoTestDataParser.decode(input).map(res => new CreateOutputHtmlProxyAutoTestData(res));
    }
    static unsafeDecode(input) {
        return CreateOutputHtmlProxyAutoTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateOutputHtmlProxyAutoTestDataParser.encode(data);
    }
    static schema() {
        return CreateOutputHtmlProxyAutoTestDataParser.schema();
    }
}
